import type { RouterChildContext } from 'react-router-dom';
import type { BrandType } from '../common/types/queries/currentUserForLayoutQuery/models';
import { routes } from '../constants/routesAndApisConstants';
import { SUB_SESSION_QUERY_PARAM } from '../subSession/wireContract';
import { withSubSessionParam } from '../subSession/withSubSessionParam';

/**
 * Adds this tab's stored landing parameters to `url` without overriding its own. The stored
 * `ibe.ss` is skipped, since it may be old or another tab's; `withSubSessionParam` adds the id.
 */
export const withStoredUtmParams = (url: string): string => {
  const knownKeys = new Set(new URL(url).searchParams.keys());
  const storedUtmParams = sessionStorage.getItem('ibe.siteContext.utmParams');
  if (!storedUtmParams) {
    return url;
  }

  // Appended as raw pairs: re-serializing the URL's own query could break signed links.
  const addedPairs = storedUtmParams.split('&').filter((pair) => {
    const key = new URLSearchParams(pair).keys().next().value;
    if (key === undefined || key === SUB_SESSION_QUERY_PARAM || knownKeys.has(key)) {
      return false;
    }
    knownKeys.add(key);
    return true;
  });
  if (addedPairs.length === 0) {
    return url;
  }

  const hashIndex = url.indexOf('#');
  const beforeHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
  const separator = !beforeHash.includes('?') ? '?' : /[?&]$/.test(beforeHash) ? '' : '&';

  return `${beforeHash}${separator}${addedPairs.join('&')}${hash}`;
};

export const redirectToActualUrl = (
  brand: BrandType,
  history: RouterChildContext['router']['history'],
  actualUrl: string,
  orderBrandCode?: string | null,
  orderBrandName?: string | null,
) => {
  if (brand.code.toLowerCase() === orderBrandCode?.toLowerCase()) {
    window.location.assign(
      withSubSessionParam(withStoredUtmParams(actualUrl), { isBackendUrl: true }),
    );
  } else {
    history.push(routes.NEW_BRAND_REDIRECTION, {
      brand: {
        code: orderBrandCode,
        name: orderBrandName,
        url: actualUrl,
      },
      redirectionType: 'order-login',
    });
  }
};
